'use client';

import React from 'react';

interface State {
  postRender: undefined | (() => void);
  toggle: number;
}

export const useForceUpdateState = (): [number, (postRender?: () => void) => void] => {
  const [state, forceUpdate] = React.useState<State>({
    postRender: undefined,
    toggle: 1,
  });

  const update = React.useCallback((postRender?: () => void) => {
    forceUpdate(old => ({
      postRender: postRender,
      toggle: old.toggle + 1,
    }));
  }, []);

  React.useEffect(() => {
    const postRender = state.postRender;
    if (postRender) {
      postRender();
    }
  }, [state.postRender]);

  return [state.toggle, update];
};

export const useForceUpdate = (): ((postRender?: () => void) => void) => {
  return useForceUpdateState()[1];
};
